import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const Form = () => (
  <ComponentDocs name="<Form/>" entry="Form" propsEntry="FormProps">
    <ComponentExample
      name="Builder controlled"
      description="The state for a Form component can be managed by a FormBuilder."
      import={import("examples/Forms/Form/BuilderControlledExample")}
      rawImport={import("examples/Forms/Form/BuilderControlledExample?raw")}
    />
    <ComponentExample
      name="Manual controlled"
      description="The state for a Form component can be managed manually."
      import={import("examples/Forms/Form/ManualControlledExample")}
      rawImport={import("examples/Forms/Form/ManualControlledExample?raw")}
    />
    <ComponentExample
      name="Render-as-function"
      import={import("examples/Forms/Form/RenderAsFunctionExample")}
      rawImport={import("examples/Forms/Form/RenderAsFunctionExample?raw")}
    />
  </ComponentDocs>
);

export default Form;
